module.exports = __webpack_public_path__ + "530628fc58ab43a17e580d32d0274d00.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/channels/channel_2.png
// module id = 338
// module chunks = 7